import { useQuery } from '@tanstack/react-query';

import { FINANCE_SUMMARY_MOCK, TRANSACTIONS_MOCK } from './finances.mock';

import type { FinanceSummary, TransactionListResponse } from './finances.types';

/**
 * Query Key Factory for the Finances domain.
 */
export const financesQueryKeys = {
  all: ['finances'] as const,
  summary: () => [...financesQueryKeys.all, 'summary'] as const,
  transactions: () => [...financesQueryKeys.all, 'transactions'] as const,
};

/**
 * Returns the headline financial KPIs.
 *
 * TODO: swap the mock resolution for `financesService.getSummary()` once the
 * rewrite exposes `GET /admin/finances/summary`.
 */
export const useGetFinanceSummary = () => {
  return useQuery({
    queryKey: financesQueryKeys.summary(),
    queryFn: async (): Promise<FinanceSummary> => {
      return FINANCE_SUMMARY_MOCK;
    },
  });
};

/**
 * Returns the recent transactions feed.
 *
 * TODO: swap the mock resolution for `financesService.listTransactions()`
 * once the rewrite exposes `GET /admin/finances/transactions`.
 */
export const useGetTransactions = () => {
  return useQuery({
    queryKey: financesQueryKeys.transactions(),
    queryFn: async (): Promise<TransactionListResponse> => {
      return { items: TRANSACTIONS_MOCK, total: TRANSACTIONS_MOCK.length };
    },
  });
};
